import gql from 'graphql-tag';
export default gql`
mutation ($args: FA_TemporaryOrderInputs!){
    fakturaAssist{
    	createFA_TemporaryOrder(args: $args){
	    	id
	 	}
 	}
}`;
